export default [
  {
    text: 'Участие в международной научной конференции <a href="https://openreadings.eu/">OpenReadings</a> в Вильнюсе.',
    year: '2026',
  },
  {
    text: 'Членство в <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> летом 2024 года.',
    year: '2024',
  },
  { text: 'Сертификат по английскому языку Acert B2', year: '2024' },
  {
    text: 'Стипендия в рамках программы <a href="https://www.stypendia-pomostowe.pl">Мостовые стипендии</a>.',
    year: '2023',
  },
  {
    text: 'Повторное получение стипендии в рамках программы <a href="https://www.podparpackie.edu.pl">Стипендиальная поддержка одаренных учащихся</a>.',
    year: '2022',
  },
  {
    text: 'Проект <a href="https://soulgraphy.me">Soulgraphy</a> достиг 100 000 просмотров в интернете.',
    year: '2021',
  },
  {
    text: 'Стипендия в рамках программы <a href="https://www.podparpackie.edu.pl">Стипендиальная поддержка одаренных учащихся</a>.',
    year: '2020',
  },
  {
    text: 'Лауреат всепольского конкурса по физике «Albus» (8-е место).',
    year: '2019',
  },
  { text: 'Лауреат регионального конкурса по физике.', year: '2019' },
  {
    text: 'Двойной лауреат всепольского конкурса «Olimpus» по математике (5-е место) и физике (9-е место).',
    year: '2019',
  },
]
